// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3b6b80c6","455":"d9fb736b","977":"f3caeabb"}[chunkId] + ".chunk.js";
};